<template>
	<p v-if="form.errors.has(field)" class="help is-danger">
		{{ form.errors.get(field) }}
	</p>
</template>

<script>
export default {
	name: 'HasError',

	props: {
		form: {
			type: Object,
			required: true
		},

		field: {
			type: String,
			required: true
		}
	}
}
</script>
